// extracted by mini-css-extract-plugin
export default {"tableWrapper":"tableWrapper---NDlFX","pageSizeRow":"pageSizeRow---kiaqx","pageSizeLabel":"pageSizeLabel---MIO1r","pageSizeSelect":"pageSizeSelect---YBAJp"};